const login = {
  title: "مرحبا بك",
  subTitle: "سجل الدخول للبدء",
  subTitle2: "الدخول",
  pageTitle: "تسجيل الدخول",
  pageSubtitle: "أدخل بيانات حسابك لتسجيل الدخول.",
  labels: {
    email: "البريد الإلكتروني",
    emailAddress: "البريد الإلكتروني",
    password: "كلمة المرور",
    remember: "تذكرني المرة القادمة",
    forgetPassword: "نسيت كلمة المرور؟",
    forgotPasswordPrefix: "نسيت كلمة المرور؟",
    resetPasswordLink: "إعادة تعيين كلمة المرور",
    registerFooter: "ليس لديك حساب؟",
    registerCompany: "سجّل شركتك",
    signin: "تسجيل الدخول",
    logIn: "تسجيل الدخول",
    admin: "مسئول",
    supervisor: "مشرف",
    signInAsSupervisor: "تسجيل الدخول كمشرف",
    otherRole: "دور آخر",
    visitorRole: "موظف",
    client: "عميل",
    signInAs: "نوع الحساب",
  },
  placeholders: {
    email: "useremail@example.com",
    password: "ادخل كلمة المرور",
  },
  // A user of an Inactive company signs in (PROLINE-4124).
  deactivatedAccount: {
    title: "تم إيقاف هذا الحساب",
    description:
      "تم إيقاف وصول شركتك بواسطة أحد مسؤولي يورم. يرجى التواصل مع فريق الدعم لمزيد من المعلومات.",
    supportTitle: "دعم يورم",
    backToSignIn: "العودة لتسجيل الدخول",
  },
};

export default login;
